import React from 'react';
import styled from 'styled-components';

const DismissSpan = styled.span`
  cursor: pointer;
  margin-left: 4px;
  margin-top: 3px;
`;

const ErrorDismissButton = ({ onClick }) => (
  <DismissSpan
    onClick={onClick}
    className='k-icon k-i-close'
  />
);

export default ErrorDismissButton;
